import { render, staticRenderFns } from "./Borderos.vue?vue&type=template&id=6d7800d4&scoped=true&"
import script from "./Borderos.vue?vue&type=script&lang=js&"
export * from "./Borderos.vue?vue&type=script&lang=js&"
import style0 from "./Borderos.vue?vue&type=style&index=0&id=6d7800d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7800d4",
  null
  
)

export default component.exports